import { useCallback, useContext, useEffect } from 'react'

import OrganizationsContext from 'containers/organizations/organizationsContext'
import InputField from 'components/InputField'
import useGetNotificationToken from 'containers/apikeys/useGetApiToken'

const NotificationTokenView = () => {
  const { currentOrganization } = useContext(OrganizationsContext)
  const [notificationToken, getNotificationToken] = useGetNotificationToken(currentOrganization.id)

  const getData = useCallback(async () => {
    if (currentOrganization.id) {
        getNotificationToken()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentOrganization.id])

  const handleCopyNotificationToken = (e) => {
    e.preventDefault()
    if (notificationToken !== null && notificationToken !== undefined) {
      navigator.clipboard.writeText(notificationToken.access_token)
    }
  }

  useEffect(() => {
    getData()
  }, [currentOrganization.id, getData])

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
        <InputField
          type="text"
          label="Notification Token"
          value={notificationToken ? notificationToken.access_token : ''}
          style={{
            width:
            notificationToken && notificationToken.access_token
                ? notificationToken.access_token.length * 9 + 'px'
                : '200px',
            maxWidth: '400px',
          }}
          disabled={true}
        />
        <button
          onClick={handleCopyNotificationToken}
          style={{
            backgroundColor: 'transparent',
            border: 'none',
            cursor: 'pointer',
          }}
        >
          <span className="material-icons-outlined saved-icon non-selectable">
            copy
          </span>
        </button>
      </div>
    </div>
  )
}

export default NotificationTokenView
